import React, {Component, PropTypes} from 'react'
import {Row, Col, Card, Button} from 'react-materialize';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import safetyandsecurity from '../../images/safetyandsecurity.png';


import {CSVLink} from "react-csv";
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {injectIntl, intlShape} from 'react-intl';
import DatePicker from "react-datepicker";


class ChecklistTrabalhadores extends Component {

    constructor(props){
        super(props);

        this.showDiv1= this.showDiv1.bind(this);
        this.showDiv2= this.showDiv2.bind(this);
        this.showDiv3= this.showDiv3.bind(this);
        this.showDiv4= this.showDiv4.bind(this);
        this.showDiv5= this.showDiv5.bind(this);

        this.handleDownloadPDF= this.handleDownloadPDF.bind(this);

        this.state ={
            showComponent1: false,
            showComponent2: false,
            showComponent3: false,
            showComponent4: false,
            showComponent5: false,

            headers: [
                {label: "Seu nome", key: "name"},
                {label: "Data", key: "data"},
            ],

            data: [
                { pergunta: "Os trabalhadores são filiados a algum sindicato?", resposta: "Sim ou não"},
                { pergunta: "O sindicato tem um membro especificamente treinado para tratar de questões de saúde e segurança neste local de trabalho?", resposta: "Sim ou não"},
                { pergunta: "Existe um comitê de gerenciamento sindical em Saúde e Segurança Ocupacional e está funcionando regularmente?", resposta: "Sim ou não"},
                { pergunta: "Existe um acordo de negociação coletiva, com disposições sobre Saúde e Segurança Ocupacional, assinado entre sindicato e gerência?"
                    , resposta: "Sim ou não" },
                { pergunta: "Para questões de direitos das mulheres - existe um comitê sindical das mulheres no local de trabalho ou um representante sindical feminino, treinado para abordar questões de igualdade de gênero, direitos de maternidade e violência baseada em gênero?", resposta: "Sim ou não"},

            ],
        }
    }

/*
    headers =[
        {label: 'nome', key: 'nome'},
        {label: 'data', key: 'data'}
    ]*/

    handleDownloadPDF = () => {

        window.scrollTo(0,0);

        html2canvas(document.querySelector('#printDiv'), {  allowTaint: true,
            useCORS: true,
            logging: false,
            height: window.outerHeight + window.innerHeight,
            windowHeight: window.outerHeight + window.innerHeight, }).then( function (canvas){


            const imgData = canvas.toDataURL("image/png", 1.0);


            const pdf = new jsPDF("p", "mm", "a4");

            pdf.addImage(imgData, 'PNG', 0,0);
            pdf.save("Checklist.pdf");
        })
    };



    showDiv1 = (e) => {
        this.setState({
            showComponent1: e.target.checked,
        });
    };

    showDiv2 = (e) => {
        this.setState({
            showComponent2: e.target.checked,
        });
    };

    showDiv3 = (e) => {
        this.setState({
            showComponent3: e.target.checked,
        });
    };

    showDiv4 = (e) => {
        this.setState({
            showComponent4: e.target.checked,
        });
    };


    showDiv5 = (e) => {
        this.setState({
            showComponent5: e.target.checked,
        });
    };

    handleChangeDatePicker = date => {
        this.setState({
            startDate: date
        });
    };




    render() {

        const intl= this.props.intl;

        const placeholder = intl.formatMessage({id: 'ph.checklist1', defaultMessage: 'Nome do responsável'});
        const placeholder2 = intl.formatMessage({id: 'ph.checklist2', defaultMessage: 'Data de inspeção:'});
        const placeholder3 = intl.formatMessage({id: 'ph.checklist3', defaultMessage: 'Insira ação corretiva'});


        return (

            <Card>


                <Row>
                    <div className={"text-center"} align="center">
                        <img src={safetyandsecurity} className={"img"} alt={"Safety and security of workers logo"} width={"100"} height={"100"}/>
                    </div>
                </Row>


                <div id={"printDiv"}>   
                    <div align={"center"}>
                    <h5><b><FormattedMessage id={"worker.ch"} defaultMessage={"Checklist dos Trabalhadores"}/></b></h5>
                    </div>





                <input type={"text"} placeholder={placeholder} key={"nome"} />

                <React.Fragment>{

                    intl.locale==="en" ?

                        <DatePicker placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/> :

                        <DatePicker locale={"pt"}  dateFormat="dd/MM/yyyy" placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/>
                }</React.Fragment>

                    <div className={"margin"}>
                        <p><b><FormattedMessage id={"worker.ch"} defaultMessage={"Checklist dos Trabalhadores"}/></b></p></div>



                <div className={"forms1"}>

                    <form action={"#"} className={"formsWorks"}>

                        <p><FormattedMessage id={"worker.ch1"} defaultMessage={"Os trabalhadores são filiados a algum sindicato?"}/></p>

                        <input type={"checkbox"} id={"yes1"}/>

                        <label htmlFor={"yes1"} ><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                        <input type={"checkbox"} id={"no1"} onClick={this.showDiv1}/>

                        <label htmlFor={"no1"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>

                        {this.state.showComponent1 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }


                    </form>
                </div>

                <div className={"#forms2"}>
                    <form action={"#"}>

                        <p><FormattedMessage id={"worker.ch2"} defaultMessage={"O sindicato tem um membro especificamente treinado para tratar de questões de saúde e segurança neste local de trabalho?"}/></p>

                        <input type={"checkbox"} id={"yes2"}/>

                        <label htmlFor={"yes2"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                        <input type={"checkbox"} id={"no2"} onClick={this.showDiv2}/>

                        <label htmlFor={"no2"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent2 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                    </form>
                </div>

                <div className={"#forms3"}>
                    <form action={"#"}>

                        <p><FormattedMessage id={"worker.ch3"} defaultMessage={"Existe um comitê de gerenciamento sindical em Saúde e Segurança Ocupacional e está funcionando regularmente?"}/></p>

                        <input type={"checkbox"} id={"yes3"}/>

                        <label htmlFor={"yes3"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                        <input type={"checkbox"} id={"no3"} onClick={this.showDiv3}/>

                        <label htmlFor={"no3"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent3 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                    </form>
                </div>

                <div className={"#forms4"}>
                    <form action={"#"}>

                        <p><FormattedMessage id={"worker.ch4"} defaultMessage={"Existe um acordo de negociação coletiva, com disposições sobre Saúde e Segurança Ocupacional, assinado entre sindicato e gerência?"}/></p>

                        <input type={"checkbox"} id={"yes4"}/>

                        <label htmlFor={"yes4"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                        <input type={"checkbox"} id={"no4"} onClick={this.showDiv4}/>

                        <label htmlFor={"no4"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent4 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                    </form>
                </div>

                <div className={"#forms5"}>
                    <form action={"#"}>

                        <p><FormattedMessage id={"worker.ch5"} defaultMessage={"Para questões de direitos das mulheres - existe um comitê sindical das mulheres no local de trabalho ou um representante sindical feminino, treinado para abordar questões de igualdade de gênero, direitos de maternidade e violência baseada em gênero?"}/></p>

                        <input type={"checkbox"} id={"yes5"}/>

                        <label htmlFor={"yes5"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                        <div>
                        <input type={"checkbox"} id={"no5"} onClick={this.showDiv5}/>

                        <label htmlFor={"no5"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                        </div>
                        {this.state.showComponent5 ?
                            <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }

                    </form>
                </div>
                </div>

                <br/>



                    <Button className={"button"} onClick={this.handleDownloadPDF} >
                        PDF
                    </Button>


                <CSVLink data={this.state.data} separator={";"} filename={"checklist.csv"}>
                    <Button className={"button"}>
                       CSV
                    </Button> </CSVLink>


            </Card>

        )
    }



}



export default injectIntl(ChecklistTrabalhadores);